// Messages are loaded in plugins/02.loadConfig.ts for SSR + client hydration
export const i18nConfig = {
	legacy: false,
	locale: "en-US",
	fallbackLocale: "en-US",
	warnHtmlMessage: false,
	missingWarn: true,
	fallbackWarn: false
};
const emptyMessages = {
	"en-US": {},
	"en-AU": {}
};
export default () => ({
	...i18nConfig,
	messages: emptyMessages
});
